<template>
    <div>
        <el-skeleton v-if="dataLoading" :rows="13" animated />
        <div v-else id="trend-chart"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import { trend } from "@/api/statistic"

export default {
    data: () => ({
        trendData: [],
        dataLoading: false
    }),
    props: {
        category: {
            required: true,
            type: String | Number,
        },
        time: {
            type: Object,
            required: true,
        }
    },
    methods: {
        async getData() {
            this.dataLoading = true
            try {
                console.log('----------------------', this.category);
                const { data } = await trend({ name: this.category, ...this.time })
                console.log('trendData', data);
                this.trendData = data
                return Promise.resolve('yayy')
            } catch {
                return Promise.reject('noo')
            } finally {
                this.dataLoading = false
            }
        },
        initTrendChart() {
            const trendChart = echarts.init(document.querySelector('#trend-chart'))
            trendChart.setOption({
                xAxis: {
                    type: 'category',
                    data: [...this.trendData.map((item) => item.month)]
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: [...this.trendData.map((item) => item.month_num)],
                        type: 'line'
                    }
                ]
            })
        },
    },
    watch: {
        category() {
            this.getData().then(() => {
                this.initTrendChart()
            })
        },
        time: {
            handler() {
                this.getData().then(() => {
                    this.initTrendChart()
                })
            },
            deep: true
        }
    },
    mounted() {
        console.log(this.time);
        this.getData().then(() => {
            this.initTrendChart()
        })
    },
}
</script>

<style lang="scss" scoped>
#trend-chart {
    width: 100%;
    min-height: 500px;
}
</style>